import { bundlePlanForm } from "../components/types";

/** A bundle plan row as returned by the listing endpoint. */
export interface BundlePlanRow {
  id: string;
  mno_id?: string;
  ussd_plan_code?: number;
  bundle_id?: string;
  amount_incl_tax?: number;
  amount_excl_tax?: number;
  internal_subscription_fee?: number;
  plan_types?: string[];
  plan_name?: string;
  created_at?: string;
  updated_at?: string;
}

/** The selectable plan types. A plan can be any combination of these. */
export const PLAN_TYPE_OPTIONS = ["Voice", "Data", "SMS"];

/** Maximum plan amount permitted for both the inclusive and exclusive amounts. */
export const MAX_PLAN_AMOUNT = 9999;

/** Character limits enforced on the free text fields. */
export const BUNDLE_ID_MAX_LENGTH = 15;
export const PLAN_NAME_MAX_LENGTH = 250;

export const bundlePlanInitialState: bundlePlanForm = {
  bundle_id: "",
  amount_excl_tax: "",
  amount_incl_tax: "",
  internal_subscription_fee: "",
  plan_name: "",
};

/**
 * Builds the input configuration for the bundle plan form. The USSD plan code is
 * generated by the backend on save, so it is not part of the form.
 */
export const getBundlePlanInputs = () => ({
  "": {
    "Bundle ID": {
      required: true,
      disabled: false,
      id: "bundle_id",
      type: "input",
      maxLength: BUNDLE_ID_MAX_LENGTH,
      tabIndex: 0,
      placeholder: "Ex: 12344",
    },
    "Amount excl. Tax": {
      required: true,
      disabled: false,
      id: "amount_excl_tax",
      type: "currency",
      tabIndex: 0,
      min: 0,
      max: MAX_PLAN_AMOUNT,
    },
    "Amount incl. Tax": {
      required: true,
      disabled: false,
      id: "amount_incl_tax",
      type: "currency",
      tabIndex: 0,
      min: 0,
      max: MAX_PLAN_AMOUNT,
    },
  },
});
